/** Licence classes for the operator form (edit this list to match local licensing). */
export const LICENCE_CLASSES = [
  "Class 1 – Buses / heavy passenger",
  "Class 2 – Heavy goods vehicles",
  "Class 3 – Motorcycles",
  "Class 4 – Light motor vehicles",
  "Class 5 – Tractors / plant",
  "Other / plant ticket",
];
